// extracted by mini-css-extract-plugin
export default {"contain":"AboutUsHome_contain__CpcjD","row":"AboutUsHome_row__LYlj3","box":"AboutUsHome_box__X4ifl","partnerBox":"AboutUsHome_partnerBox__Yd0Kk"};